import { useTranslation } from 'next-i18next/pages';
import { useFormContext, useWatch } from 'react-hook-form';

import { Label, LabelForm } from '@/components/shared/ui/forms/common';
import { SelectBoxWithHookForm } from '@/components/shared/ui/forms/selects';

import {
  getInquiryLabelA11y,
  getInquirySelectA11y,
} from './InquiryFormInputs.a11y';
import type { InquiryFormType } from './InquiryFormProvider';
import { selectedInquiryValue } from './inquiryFormValues';
import { AI_ANSWER_SOURCE } from './inquirySource';
import useInquiryFormOptions from './useInquiryFormOptions';

export default function InquirySourceFields() {
  const {
    control,
    formState: { errors },
  } = useFormContext<InquiryFormType>();
  const { t } = useTranslation('common');
  const { aiServiceOptions, inquirySourceOptions } = useInquiryFormOptions();
  const selectedSource = useWatch({ control, name: 'selfReportedSource' });
  const isAiSource = selectedInquiryValue(selectedSource) === AI_ANSWER_SOURCE;

  return (
    <>
      <div className="lg:col-span-2">
        <LabelForm
          align="vertical"
          labelComponent={
            <Label
              {...getInquiryLabelA11y('selfReportedSource')}
              text={t('디플리를 어떻게 알게 되셨나요?')}
              required
            />
          }
          formComponent={
            <SelectBoxWithHookForm
              name="selfReportedSource"
              {...getInquirySelectA11y('selfReportedSource')}
              rules={{ required: t('필수 입력 사항입니다.') }}
              control={control}
              errors={errors}
              options={inquirySourceOptions}
              placeholder={t('유입 경로 선택')}
              isClearable={false}
              isRequired
            />
          }
        />
      </div>
      {isAiSource ? (
        <div className="lg:col-span-2">
          <LabelForm
            align="vertical"
            labelComponent={
              <Label
                {...getInquiryLabelA11y('selfReportedAiService')}
                text={t('사용한 AI 서비스')}
                required
              />
            }
            formComponent={
              <SelectBoxWithHookForm
                name="selfReportedAiService"
                {...getInquirySelectA11y('selfReportedAiService')}
                rules={{ required: t('필수 입력 사항입니다.') }}
                control={control}
                errors={errors}
                options={aiServiceOptions}
                placeholder={t('AI 서비스 선택')}
                isClearable={false}
                isRequired
                showSelectedIndicator
                shouldUnregister
              />
            }
          />
        </div>
      ) : null}
    </>
  );
}
